import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { UseAuthContext } from '../../context/AuthContext';
import FormFields from './FormFields';
import {  getErrorMsg } from '../utils/commonUtil';

export default function UpdateAddress({setResultData, setSearchSubmit}) {
    const { t } = useTranslation();
    const { token } = UseAuthContext();
    const [load, setLoad] = useState(false);
    const [pageInfo] = useState({
        page: 0,
        size: "5"
    });

    // form feilds
    const [searchParams, setSearchParams] = useState({
        postCode: "",
        streetBuildingId: "",
        buildingSuffix: "",
        municipalityName: "",
        streetName: "",
        districtName: "",
        floorId: "",
        suiteId: "",
        //region: "",
        coordinates: "",
        streetCode: ""
    });

    const [errors, setErrors] = useState({
        postCode: "",
        streetBuildingId: "",
        buildingSuffix: "",
        municipalityName: "",
        streetName: "",
        districtName: "",
        floorId: "",
        suiteId: "",
       // region: "",
        coordinates: "",
        streetCode: ""
    });
  
    const handleInput = (e) => {
        let id = e.target.id;
        let value = e.target.value;
        setSearchParams(pre => ({ ...pre, [id]: value }));
    }

    // Validation function to handle form field validation
    const validateField = (id, value, isOptional = false) => {
        if (isOptional && !value) {
            return null;
        }
       /* eslint-disable no-useless-escape */
        const validationRules = {
            streetName: /^[A-Za-z0-9åøæÅØÆ\s\-]+(vej|gade|plads|bro|sti|alle|torv|bakke|stræde)?$/,
            streetBuildingId: /^[A-Za-z0-9\-\/\s\.]+$/,
            buildingSuffix: /^[A-Za-z0-9\-\/\.]+$/,
            floorId: /^[A-Za-z0-9åøæÅØÆ\s\-\/\.]{1,6}(st|etage|th|g|g1|gf)?$/,
            suiteId: /^[A-Za-z0-9\-\/\.]+$/,
            postCode: /^[0-9]{4}$/,
            districtName: /^[A-Za-z0-9åøæÅØÆ\s\-\'\.]{2,50}$/,
            //region: /^[A-Za-zåøæÅØÆ\s\-]{3,20}$/,
            municipalityName: /^[A-Za-zåøæÅØÆ\s\-]{3,20}$/,
            streetCode: /^[A-Za-z0-9\-]+$/,
            coordinates: /^\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?\s*$/
        };
        /* eslint-enable no-useless-escape */
       if (!value) {
			const mandatoryText = `${id} is required`;
			return mandatoryText.charAt(0).toUpperCase() + mandatoryText.slice(1);
		} else if (!validationRules[id].test(value)) {
			const formatError = `${id} is invalid`;
			return formatError.charAt(0).toUpperCase() + formatError.slice(1);
		}
        return null;
    };

    const handleValidations = () => {
        const newErrors = {};
        Object.keys(searchParams).forEach(field => {
           const isOptional = field === "districtName" || "streetCode" || "suiteId" || "floorId" || "buildingSuffix" || "coordinates";
            const error = validateField(field, searchParams[field], isOptional);
            if (error) {
                newErrors[field] = error;
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Returns true if no errors
    }

    const searchHandler = (pageNo) => {
        if(handleValidations()) { 
            setLoad(true);
            setResultData({ data: null, loading: true, msg: t('result.loading') });
            axios.post(`/api/v2/addresses/legacy?page=${pageNo}&size=${pageInfo.size}`,
            {
                ...searchParams, floorId: searchParams.floorId ? searchParams.floorId : null,
                suiteId: searchParams.suiteId ? searchParams.suiteId : null
            }, { headers: { "Authorization": `Bearer ${token}` } })
            .then(res => {
                if (res.data.content.length === 0) {
                    setResultData({ data: null, loading: false, msg: t('result.no_data') });
                } else {
                    setResultData({ data: res.data, loading: false, msg: "" });
                }
                setLoad(false);
            })
            .catch(err => {
                setResultData({ data: null, loading: false, msg: getErrorMsg(err.message) });
                setLoad(false);
            })
        }
    }

    const reset = () => {
        setSearchParams({
            postCode: "",
            streetBuildingId: "",
            buildingSuffix: "",
            municipalityName: "",
            streetName: "",
            districtName: "",
            floorId: "",
            suiteId: "",
            //region: "",
            coordinates: "",
            streetCode: ""
        });
        setErrors({
            postCode: "",
            streetBuildingId: "",
            buildingSuffix: "",
            municipalityName: "",
            streetName: "",
            districtName: "",
            floorId: "",
            suiteId: "",
           // region: "",
            coordinates: "",
            streetCode: ""
        });
        setResultData({ data: null, loading: false, msg: "" });
    };

	const isFormValid = (searchParams.postCode!== "" &&
		searchParams.streetBuildingId!== "" &&
		searchParams.municipalityName !== "" &&
		searchParams.streetName !== "" );	
		//searchParams.region!== "" &&
		// searchParams.coordinates!== "" 
    return (
        <>
            <div className="mt-2 text-sm">             
                    <FormFields handleInput={handleInput} searchParams={searchParams} errors={errors} showCoordinates={false} />
                    <div className="row gy-1">
                        <div className="col-6 text-right">
                            <button className="btn btn-primary"
                            disabled={!isFormValid}
                               onClick={() => { searchHandler(0); setSearchSubmit(() => searchHandler) }}>{load ? t('search.wait') : t('search.search')}</button>
                        </div>
                        <div className="col-6 text-left">
                            <button className="btn btn-secondary ml-1" onClick={reset}>{t('search.reset')}</button>
                        </div>
                    </div>
            </div>          
        </>
    )
}